import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
  FormGroup,
  Modal,
} from "reactstrap"
import { post, del } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  ADD_EMERGENCY_TYPES,
  LANGUAGES_SEARCH,
  UPLOAD_FILE,
} from "../../helpers/api_endpoints"

document.title = "Add Emergency Type"

function AddEmergencyType() {
  const [title, setTitle] = useState('{"title":[{"1":""}]}')
  const [languages, setLanguages] = useState([])
  const [errorMsg, setErrorMsg] = useState("")
  const [loading, setLoading] = useState(false)
  const [valued, setValued] = useState({ title: [] })
  const [emergencyType, setEmergencyType] = useState([])
  const [emergencyTypeId, setEmergencyTypeId] = useState([])
  const [icon, setIcon] = useState("")
  const navigate = useNavigate()

  useEffect(() => {
    post(`${LANGUAGES_SEARCH}`, { status: 1 })
      .then(response => {
        setLanguages(response.data)
        // console.log(languages);
        setLoading(false)
      })
      .catch(error => {
        console.log(error)
        // navigate('/collhub');
      })
  }, [])

  const handleFileUpload = event => {
    setLoading(true)
    const file = event.target.files[0]
    post(
      `${UPLOAD_FILE}`,
      { file, type: "emergency_type_icon", fullPath: "true" },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
      .then(response => {
        const data = response.data
        setIcon(data.path)
        setLoading(false)
      })
      .catch(error => {})
  }

  const handleSubmit = () => {
    if (!icon) {
      setErrorMsg("Please upload an icon.");
      return;
    }

    const primaryTitle = valued.title.find(t => t["1"]);
    if (!primaryTitle || !primaryTitle["1"]) {
      setErrorMsg("Please enter a title for the primary language (English).");
      return;
    }

    setErrorMsg(""); // Clear any previous errors

    const config = { title, emergencyTypeId, icon };
    
    post(ADD_EMERGENCY_TYPES, config)
      .then(response => {
        if (response.code == 201) {
          navigate("/emergency-types", {
            state: { successMsg: "Emergency Type Added SuccessFully" },
          });
        }
      })
      .catch(error => {
        setErrorMsg(error?.response?.data?.message || "Emergency Type Creation Failed");
      });
  }

  const handleTitle = (languageId, value) => {
    const ln = valued.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      valued.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setTitle(JSON.stringify(valued))
  }
  

  const clearPhoto = () => {
    setIcon("")
  }
  console.log(errorMsg);
  

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Emergency Types"
            breadcrumbItem="Add Emergency Type"
          />
          
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              handleSubmit()
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                      {languages.map((language, index) => (
                        <Row key={index}>
                          <div className="form-group col-md-4 mt-2">
                            <Label className="form-label">
                              <Trans>Title ({language.name})</Trans>
                            </Label>
                            <Input
                              name="title"
                              className="form-control"
                              placeholder="Enter  Title"
                              type="text"
                              onChange={e =>
                                handleTitle(language.id, e.target.value)
                              }
                              required={language.id === 1}
                            ></Input>
                          </div>
                        </Row>
                      ))}

                      <Row>
                          <div className="form-group col-md-12 mt-2">
                            <Label className="form-label">
                              <Trans>Icon</Trans>
                            </Label>
                            <input
                              className="form-control"
                              type="file"
                              onChange={handleFileUpload}
                            />
                          </div>
                          {icon && (
                            <div>
                              <input
                                className="form-control"
                                type="button"
                                value="X"
                                onClick={clearPhoto}
                              />
                              <img src={icon} width="170" height="270" />
                            </div>
                          )}
                      </Row>
                    </Row>

                    <div className="mt-4">
                      <Button type="submit" color="danger">
                        <Trans>Submit</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddEmergencyType
